import React, { useState } from "react";
import { VoiceAssistantFaqs } from "../../components/faqData.js";

import Contact from "../../components/Contact.js";
import GetInTouch from "../../components/GetInTouch.js";
import AyanshtechAdvantage from "../../components/AyanshtechAdvantage.js";
import { Helmet } from "react-helmet-async";

const VoiceAssistant = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById("contact-section");
    contactSection.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <Helmet>
        <title>
          AI Voice Assistant Development Company India | Custom Solutions -
          Ayanshtech
        </title>
        <meta
          name="description"
          content="Leading AI Voice Assistant Development Services in India. Build custom, intelligent voice solutions with NLP, speech recognition & 24/7 support for your business."
        />

        <meta name="copyright" content="Ayanshtech Solutions" />
        <meta
          property="og:title"
          content="AI Voice Assistant Development Company India | Custom Solutions - Ayanshtech"
        />
        <meta property="og:site_name" content="Ayanshtech Solutions" />
        <meta
          property="og:url"
          content="https://ayanshtechnology.com/voice-assistant"
        />
        <meta
          property="og:description"
          content="Leading AI Voice Assistant Development Services in India. Build custom, intelligent voice solutions with NLP, speech recognition & 24/7 support for your business."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@Ayanshtech" />
        <meta
          name="twitter:title"
          content="AI Voice Assistant Development Company India | Custom Solutions - Ayanshtech"
        />
        <meta
          name="twitter:description"
          content="Leading AI Voice Assistant Development Services in India. Build custom, intelligent voice solutions with NLP, speech recognition & 24/7 support for your business."
        />
        <meta
          name="twitter:image"
          content="https://ayanshtechnology.com/assets/logo.png"
        />

        <link
          rel="canonical"
          href="https://ayanshtechnology.com/voice-assistant"
        ></link>
      </Helmet>
      <div className="flex flex-col items-center justify-center p-6 gradient-background">
        <div className=" p-4 w-full">
          <div className="flex flex-col lg:flex-row items-center lg:space-x-16">
            <div className="lg:w-3/4  lg:text-left">
              <h1 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4">
                AI Voice Development Company in India{" "}
              </h1>
              <p className="sm:text-base md:text-lg lg:text-lg leading-relaxed mb-3">
                At Ayanshtech, we are a leading AI Voice Development Company in
                India, empowering businesses to enhance customer interactions
                through intelligent voice technology. With the growing demand
                for AI-powered voice assistants, we help you build seamless,
                hands-free, and personalized user experiences that make
                communication smarter and more engaging.
                <br />
                <br />
                Our AI voice development services include custom voice assistant
                integration, speech recognition, NLP-based responses, and
                multi-platform voice solutions tailored to your business needs.
                Whether you want to create a virtual assistant, automate
                customer support, or enable voice-driven applications, we
                deliver scalable and high-performance solutions.
              </p>
              <button
                onClick={scrollToContact}
                className="bg-green-600 text-white hover:bg-yellow-500 hover:text-green-700 hover:border hover:border-yellow-500 font-semibold py-2 px-4 rounded-full mt-6"
              >
                Get Started
              </button>
            </div>

            <div className="flex justify-center mb-12 lg:mb-0 mt-5">
              <img
                src="\assets\images\devops\voiceAssisImg1.avif"
                alt="AI Voice Development Company in India"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>
          </div>
        </div>

        <div className="text-center mb-5 mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Key Features of Our Voice Assistant Services
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our voice assistant solutions are powered by cutting-edge AI
            technology to deliver natural and intuitive user interactions,
            ensuring a seamless experience for your customers.
          </p>
        </div>

        <div className=" p-6 ">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon20.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Natural Language Processing (NLP)</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon19.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Voice-Activated Commands</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon18.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Multi-Platform Integration</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon17.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Personalized User Experiences</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon16.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Real-Time Analytics</p>
            </div>

            <div className="flex items-center space-x-4">
              <img
                src="\assets\icons\techIcons\icon15.png"
                alt="icon"
                className="w-10 h-10"
              />
              <p className="text-lg">Context-Aware Responses</p>
            </div>
          </div>
        </div>

        <div className="text-center mt-10">
          <h2 className="sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Why Choose Our Voice Assistant Solutions?
          </h2>
          <p className="sm:text-base md:text-lg lg:text-xl text-gray-600 font-semibold mt-4 max-w-6xl mx-auto">
            Our team specializes in delivering tailored voice assistant
            solutions designed to enhance productivity, customer engagement, and
            operational efficiency.
          </p>
        </div>

        <div className=" ">
          <div className="flex flex-col md:flex-row items-center justify-between">
            <div className="w-full md:w-1/3 p-4">
              <img
                src="\assets\images\devops\voiceAssisImg2.avif"
                alt="Voice Assistant Demo"
                className="w-full h-auto sm:w-3/4 md:w-2/3 lg:w-full object-contain"
              />
            </div>

            <div className="md:w-1/2 lg:w-3/4 p-4 grid grid-cols-1 md:grid-cols-2 gap-6">
              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon14.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    AI-powered voice recognition for precise and accurate
                    interactions
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon13.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Easy integration with existing systems and applications
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon12.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Fully customizable solutions to meet your business needs
                  </p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <img
                  src="\assets\icons\techIcons\icon11.png"
                  alt="icon"
                  className="w-10 h-10"
                />
                <div>
                  <p className="text-lg">
                    Scalable technology to grow with your business
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <AyanshtechAdvantage />

        <div className="max-w-3xl mx-auto p-4 mt-10 w-full">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-center mb-8">
            FAQs
          </h2>
          {VoiceAssistantFaqs.map((faq, index) => (
            <div key={index} className="border-b-2 border-blue-300">
              <button
                onClick={() => toggleFAQ(index)}
                className={`w-full text-left py-4 flex justify-between items-center focus:outline-none ${
                  activeIndex === index
                    ? "bg-blue-600 text-white px-5 rounded-2xl"
                    : ""
                }`}
              >
                <span className="text-lg">{faq.question}</span>
                <span className="text-2xl">
                  {activeIndex === index ? "-" : "+"}
                </span>
              </button>
              {activeIndex === index && (
                <div className="p-4 text-gray-700">{faq.answer}</div>
              )}
            </div>
          ))}
        </div>

        <div id="contact-section">
          <Contact />
        </div>

        <GetInTouch />
      </div>
    </>
  );
};

export default VoiceAssistant;
